<template>
	<div>
		<CubePage type="myorder-view" title="小店管理">
			<div slot="content" class="content">
				<van-search placeholder="请输入小店名称" v-model="storename" @search="onSearch" show-action>
					<div slot="action" @click="onSearch">
						<van-button type="primary">搜索</van-button>
					</div>
				</van-search>
				<div style="margin-top: 10px;">
					<van-empty v-if="isNoData" class="custom-image" description="您还没有相关的小店">
						<template #image>
							<img src="@/assets/img/empty.png" alt="">
						</template>
					</van-empty>
					<van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
						:immediate-check="false">
						<div class="list-box">
							<div class="list-item" v-for="(item,index) in listData" :key="index">
								<div class="item-card">
									<van-image class="card-img" round :src="item.avatar" />
									<div class="card-content">
										<div class="conten-title">
											<p class="t ells">{{item.storename}}</p>
											<!-- <p class="r">
												<van-icon name="underway-o" />
												<span style="padding-left: 5px;">2022-5-11</span>
											</p> -->
										</div>
										<div class="conten-desc ells">
											<p>
												<van-icon name="user-o" style="padding-right: 5px;" />
												联系人:<span style="padding-left: 5px;">{{item.contacts}}</span>
											</p>
										</div>
										<div class="conten-desc">
											<p>
												<van-icon name="phone-o" style="padding-right: 5px;" />
												联系电话:<span style="padding-left: 5px;">{{item.mobile}}</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</van-list>
				</div>

			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				storename: '',
				loading: false,
				finished: false,
				isNoData: false,
				listData: [],
				pageIndex: 1,
				pageTotal: 0,
			}
		},
		created() {
			this.get_my_order()
		},
		methods: {
			onSearch() {
				this.clearContainer();
				this.get_my_order();
			},
			// 上滑加载更多
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.get_my_order();
				}, 1000)
			},
			get_my_order() {
				var url = "/addons/litestore/api.supplier/storeList"
				let that = this;
				//这里直接调用网络接口
				util.post(url, {
						page: that.pageIndex,
						storename: that.storename
					},
					function(result) {
						that.loading = false;
						//这里对状态 进行分类 
						that.pageTotal = result.data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (result.data.list == null || result.data.list.length === 0) {
							// 加载结束
							that.finished = true;
							return;
						}
						// 将新数据与老数据进行合并
						that.listData = that.listData.concat(result.data.list);

						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.listData.length >= that.pageTotal) {
							that.finished = true;
						}
					},
				);
			},
			// 初始化数据
			clearContainer() {
				this.loading = false
				this.finished = false
				this.listData = []
				this.isNoData = false
				this.pageIndex = 1
				this.pageTotal = 0
			},

		}
	}
</script>
<style lang="less">
	@import url("../../../assets/css/order.css");
	@import url("../../../assets/css/listboxless.less");
</style>
<style lang="less" scoped="scoped">
	.van-search {
		.van-search__action {
			line-height: 0;
		}

		.van-button {
			height: 34px;
		}
	}

	.list-box {
		.list-item {
			margin-bottom: 10px;
			background-color: #FFFFFF;

			.item-card {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 20px 15px;
				box-sizing: border-box;

				.card-img {
					width: 60px;
					height: 60px;
				}

				.v {
					width: 20px;
				}

				.card-content {
					flex: 1;
					margin: 0 15px;

					.red-text {
						color: #d40000;
					}

					.conten-title {
						display: flex;
						justify-content: space-between;

						.t {
							max-width: 140px;
							font-size: 16px;
							font-weight: 600;
						}

						.r {
							font-size: 14px;
						}
					}

					.conten-desc {
						padding-top: 8px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						p {
							color: #a3a3a3;
							font-size: 14px;
						}
					}
				}
			}

			.item-btns {
				height: 50px;
				display: flex;
				justify-content: space-around;
				align-items: center;

				.btn-item {

					.van-icon,
					.iconfont {
						vertical-align: middle;
						font-size: 20px;
					}

					.btn-text {
						font-size: 14px;
						padding: 0 5px;
					}
				}
			}
		}
	}
</style>
